import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-terms',
	templateUrl: './terms-app.component.html',
	styleUrls: ['./terms-app.component.scss'],
})
export class TermsAppComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
